export * from "./home-page.template";
export { HomePageTemplate as default } from "./home-page.template";
